'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mapPropsAndThemeToStyle = exports.defaultStyle = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectResolvePath = require('object-resolve-path');

var _objectResolvePath2 = _interopRequireDefault(_objectResolvePath);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultStyle = exports.defaultStyle = {
  '&.checkbox': {
    fontSize: '14px'
  },
  '& .check': {
    margin: '0 10px',
    position: 'relative',
    cursor: 'pointer'
  },
  '& .check .checkbox-unchecked': {
    opacity: 1,
    transition: 'opacity 200ms'
  },
  '& .check .checkbox-checked': {
    position: 'absolute',
    left: 0,
    top: 0,
    opacity: 0,
    transform: 'scale(0)',
    transition: 'transform 200ms ease-in-out,opacity 200ms'
  },
  '& .check.checked .checkbox-unchecked': {
    opacity: 0
  },
  '& .check.checked .checkbox-checked': {
    opacity: 1,
    transform: 'scale(1)'
  },
  '& label, & .check': {
    display: 'inline-block'
  }
};

var mapPropsAndThemeToStyle = exports.mapPropsAndThemeToStyle = function mapPropsAndThemeToStyle(props, theme) {
  return (0, _extends3.default)({}, (0, _objectResolvePath2.default)(theme, 'Checkbox.css') || {});
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/@nike/ruxac/components/form/Checkbox/Checkbox.style.js
// module id = 507
// module chunks = 0